import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Modal } from 'react-bootstrap';
import Tree, { TreeNode } from 'rc-tree';
import 'rc-tree/assets/index.css';
import Select from 'react-select';
import { IoCaretUpOutline, IoCaretDownOutline } from 'react-icons/io5';
import x from '../../assest/images/x.png';
import Icon9 from '../../assest/images/Icon9.png';
import Icon5 from '../../assest/images/Icon5.png';
import Icon3 from '../../assest/images/Icon3.png';
import Image from '../common/image';
import config from "../../envconfig";
import { UserContext } from '../common/UserContext';
import CustomSingleValue from '../common/CustomSingleValue';

const MenuTree = ({ selectedKeys, setSelectedKeys, disabled, allAvailableKeys, isTreeView, menuData }) => {
    const [expandedKeys, setExpandedKeys] = useState([]);

    const handleCheck = (key) => {
        const updatedKeys = [...selectedKeys];
        const keyIndex = updatedKeys.indexOf(key);
        if (keyIndex > -1) {
            updatedKeys.splice(keyIndex, 1);
        } else {
            updatedKeys.push(key);
        }
        setSelectedKeys(updatedKeys);
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const allSubmenuKeys = isTreeView
                ? allAvailableKeys.filter(key => key.type === 'submenu').map(key => key.key)
                : allAvailableKeys;
            setSelectedKeys(allSubmenuKeys);
        } else {
            setSelectedKeys([]);
        }
    };

    const handleTreeCheck = (checkedKeys) => {
        const submenuKeys = checkedKeys.filter(key => key.startsWith('submenu-'));
        setSelectedKeys(submenuKeys);
    };

    const handleExpand = (expandedKeys, { node, expanded }) => {
        const key = node.key;

        setExpandedKeys(prev =>
            expanded
                ? [...prev, key]                 // expand this one
                : prev.filter(k => k !== key)    // collapse this one
        );
    };


    const renderTreeNodes = (data) => {
        return data.map(item => {
            const menuKey = `menu-${item.MNM_Id}-${item.MNM_MenuName}`;
            return (
                <TreeNode key={menuKey} title={item.MNM_MenuName} disableCheckbox={disabled}>
                    {item.subMenus.map(subItem => {
                        const submenuKey = `submenu-${subItem.SMNM_Id}-${subItem.SMNM_SubMenuDisplay}`;
                        return (
                            <TreeNode
                                key={submenuKey}
                                title={subItem.SMNM_SubMenuDisplay}
                                disableCheckbox={disabled}
                            />
                        );
                    })}
                </TreeNode>
            );
        });
    };

    return (
        <div>
            {allAvailableKeys.length > 0 && (
                <div className="checkbox-row">
                    <label className="checkbox-label">
                        <input
                            type="checkbox"
                            checked={isTreeView
                                ? selectedKeys.length === allAvailableKeys.filter(key => key.type === 'submenu').length
                                : selectedKeys.length === allAvailableKeys.length}
                            onChange={handleSelectAll}
                            disabled={disabled}
                        />
                        <span><strong>Select All</strong></span>
                    </label>
                </div>
            )}
            {allAvailableKeys.length > 0 ? (
                isTreeView ? (
                    <Tree
                        checkable
                        checkedKeys={selectedKeys}
                        onCheck={handleTreeCheck}
                        expandedKeys={expandedKeys}
                        onExpand={handleExpand}
                        disabled={disabled}
                        selectable={false}
                        onClick={(e, node) => {
                            if (e.target.className.includes('rc-tree-switcher')) {
                                const key = node.key;
                                setExpandedKeys(prev =>
                                    prev.includes(key)
                                        ? prev.filter(k => k !== key)
                                        : [...prev, key]
                                );

                            }
                            e.stopPropagation();
                        }}
                    >
                        {renderTreeNodes(menuData)}
                    </Tree>
                ) : (
                    allAvailableKeys.map((key, index) => {
                        const [, ...roleNameParts] = key.split('-');
                        const roleName = roleNameParts.join('-');
                        return (
                            <div className="checkbox-row" key={key} style={{ width: "100%" }}>
                                <label
                                    className="checkbox-label"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        width: "100%",
                                        whiteSpace: "nowrap"
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={selectedKeys.includes(key)}
                                        onChange={() => handleCheck(key)}
                                        disabled={disabled}
                                    />

                                    <span
                                        style={{
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            flex: 1
                                        }}
                                        title={roleName}   // shows full text on hover
                                    >
                                        {roleName}
                                    </span>
                                </label>
                            </div>

                        );
                    })
                )
            ) : (
                <div className="no Rights-message">No rights available</div>
            )}
        </div>
    );
};

function GroupMaster() {
    const { groupId } = useParams();
    const isEditing = !!groupId;
    const [formdata, setFormdata] = useState({
        GRPM_GroupName: '',
        GRPM_ITPolicyId: '',
        GRPM_GroupStatus: 1,
        GRPM_CompanyGrpId: '',
        GRPM_CompanyID: '',
        MNM_MenuName: [],
        RLM_MachineType: '',
        GRPM_GroupType: '',
    });
    const [companyNames, setCompanyNames] = useState([]);
    const [companyName, setCompanyName] = useState([]);
    const [selectedPolicyDetails, setSelectedPolicyDetails] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedGroupRights, setSelectedGroupRights] = useState([]);
    const [popupSelectedSubMenus, setPopupSelectedSubMenus] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [showSelectCompany, setShowSelectCompany] = useState(false);
    const [tableList, setTableList] = useState([]);
    const [machineTypes, setMachineTypes] = useState([]);
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId, UM_UserType, CM_CompanyName } = useContext(UserContext);
    const [emptyFields, setEmptyFields] = useState([]);
    const [message, setMessage] = useState('');
    const [isGroupNameValid, setIsGroupNameValid] = useState(true);
    const [scps, setScps] = useState([]);
    const [selectedSCP, setSelectedSCP] = useState('');
    const [allAvailableKeys, setAllAvailableKeys] = useState([]);
    const [isTreeView, setIsTreeView] = useState(false);
    const [menuData, setMenuData] = useState([]);
    const [editingRowIndex, setEditingRowIndex] = useState(null);
    const [groupTypeOptions, setGroupTypeOptions] = useState([]);
    const [selectedGroupTypeId, setSelectedGroupTypeId] = useState(null);
    const [showGroupTypeField, setShowGroupTypeField] = useState(true);
    const [shouldShowSCPColumn, setShouldShowSCPColumn] = useState(false);
    const [selectedCompanyId, setSelectedCompanyId] = useState('');
    const [originalGroupData, setOriginalGroupData] = useState(null);
    const [isSelectOpen, setIsSelectOpen] = useState(null);
    const [selectedMachineType, setSelectedMachineType] = useState(null);
    const [removeConfirmationModal, setRemoveConfirmationModal] = useState(false);
    const [rowToRemove, setRowToRemove] = useState(null);
    const navigate = useNavigate();
    const [showUpdateRequired, setShowUpdateRequired] = useState(false);
    const [loading, setLoading] = useState(false);

    const toastRef = useRef(null);
    const showToast = (type, message, options = {}) => {
        if (toastRef.current && toast.isActive(toastRef.current)) {
            toast.update(toastRef.current, {
                render: message,
                type,
                autoClose: 3000,
                ...options,
            });
        } else {
            toastRef.current = toast[type](message, {
                autoClose: 3000,
                ...options,
            });
        }
    };

    const handleSelectOpen = (selectName) => {
        setIsSelectOpen(selectName);
        // if (selectName === "GRPM_GroupStatus" || selectName === "RLM_MachineType" || selectName === "GRPM_ITPolicyId") {
        if (selectName === "GRPM_GroupStatus" || selectName === "RLM_MachineType") {
            setTimeout(() => {
                const mainContainer = document.querySelector('.main_container');
                const dropdown = document.querySelector('.routing_select-box .react-select__menu');
                const dropdownHeight = dropdown ? dropdown.offsetHeight : 100; // Fallback height
                const gap = 20; // Desired gap
                if (mainContainer) {
                    mainContainer.style.paddingBottom = `${dropdownHeight + gap}px`;
                    mainContainer.scrollTo({
                        top: mainContainer.scrollHeight,
                        behavior: "smooth"
                    });
                }
            }, 100);
        }
    };

    const handleSelectClose = () => {
        setIsSelectOpen(null);
        const mainContainer = document.querySelector('.main_container');
        if (mainContainer) {
            mainContainer.style.paddingBottom = ''; // Reset padding
        }
    };


    useEffect(() => {
        // 🔥 Do nothing until a valid group type is selected
        const groupTypeId = parseInt(selectedGroupTypeId, 10);
        if (!groupTypeId || (!selectedCompanyId && !UM_CompanyID)) return;

        const fetchAllMenuKeys = async () => {
            const machineType = parseInt(formdata.RLM_MachineType, 10);

            if (!machineType) {
                setAllAvailableKeys([]);
                setIsTreeView(false);
                setMenuData([]);
                return;
            }

            try {

                if (parseInt(machineType) === 1) {
                    const companyId = parseInt(selectedCompanyId || UM_CompanyID, 10);
                    console.log("selectedCompanyId", selectedCompanyId);
                    const response = await fetch(
                        `${config.API_URL}/menu/${companyId}/${groupTypeId}`
                    );
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }

                    const data = await response.json();

                    if (!Array.isArray(data) || data.length === 0) {
                        showToast('error', "Company Configuration is missing for this Machine Type : SmartTrackerPlus.");
                        setAllAvailableKeys([]);
                        setIsTreeView(false);
                        setMenuData([]);
                        return;
                    }

                    const menuMap = {};
                    const keys = [];

                    data.forEach((item) => {
                        if (!menuMap[item.MNM_MenuName]) {
                            menuMap[item.MNM_MenuName] = {
                                MNM_Id: item.MNM_MenuID,
                                MNM_MenuName: item.MNM_MenuName,
                                subMenus: []
                            };

                            keys.push({
                                type: "menu",
                                MNM_MenuID: item.MNM_MenuID,
                                displayName: item.MNM_MenuName
                            });
                        }

                        if (item.SMNM_SubMenuID) {
                            menuMap[item.MNM_MenuName].subMenus.push({
                                SMNM_Id: item.SMNM_SubMenuID,
                                SMNM_SubMenuDisplay: item.SMNM_SubMenuDisplay
                            });

                            keys.push({
                                type: "submenu",
                                MNM_MenuID: item.MNM_MenuID,
                                SMNM_SubMenuID: item.SMNM_SubMenuID,
                                displayName: item.SMNM_SubMenuDisplay,
                                key: `submenu-${item.SMNM_SubMenuID}-${item.SMNM_SubMenuDisplay}`
                            });
                        }
                    });

                    setAllAvailableKeys(keys);
                    setIsTreeView(true);
                    setMenuData(Object.values(menuMap));
                } else {
                    const response = await fetch(
                        `${config.API_URL}/machineroles/${machineType}`
                    );
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }

                    const data = await response.json();
                    const keys = data.map(
                        (item) => `${item.STM_Mask}-${item.STM_RoleName}`
                    );

                    setAllAvailableKeys(keys);
                    setIsTreeView(false);
                    setMenuData([]);
                }
            } catch (err) {
                console.error(
                    `fetchAllMenuKeys: Failed to fetch rights for AppId ${formdata.RLM_MachineType}:`,
                    err
                );
                logAction(
                    `fetchAllMenuKeys(): Failed to fetch rights for AppId ${formdata.RLM_MachineType}: ${err.message}`,
                    true
                );
                //toast.error("Failed to load group rights data. Please try again.");
                setAllAvailableKeys([]);
                setIsTreeView(false);
                setMenuData([]);
            }
        };

        fetchAllMenuKeys();
    }, [formdata.RLM_MachineType, selectedGroupTypeId, selectedCompanyId]);



    useEffect(() => {
        const fetchEnumOptions = async () => {
            try {
                const response = await fetch(`${config.API_URL}/enumtype`);
                if (!response.ok) throw new Error('Failed to fetch enum options');
                const data = await response.json();
                const formattedOptions = data.map((item) => ({
                    value: item.EnumVal,
                    label: item.Description
                }));

                let allowedIds = [];
                if (parseInt(UM_UserType) === 0) {
                    setShowSelectCompany(true);
                    allowedIds = [1, 2, 3, 4];
                } else if (parseInt(UM_UserType) === 1) {
                    allowedIds = isEditing ? [1, 2, 3, 4] : [2, 3, 4];
                } else if (parseInt(UM_UserType) === 2) {
                    allowedIds = isEditing ? [1, 2] : [2];
                } else if (parseInt(UM_UserType) === 3) {
                    allowedIds = isEditing ? [1, 3] : [3];
                }

                console.log("UM_UserType:", UM_UserType);
                console.log("Allowed IDs before filter:", allowedIds);
                console.log("Formatted Options:", formattedOptions);

                const filteredOptions = formattedOptions.filter(opt => allowedIds.includes(opt.value));
                setGroupTypeOptions(filteredOptions);

                if (filteredOptions.length === 1) {
                    const singleOption = filteredOptions[0];
                    setSelectedGroupTypeId(singleOption.value);
                    setFormdata(prev => ({
                        ...prev,
                        GRPM_GroupType: singleOption.value
                    }));
                    setShowGroupTypeField(false);
                    if (singleOption.value === 3) {
                        if (parseInt(UM_UserType) === 1) {
                            setShouldShowSCPColumn(true);
                        }

                        fetchSCPData(UM_CompanyID, selectedScpId, parseInt(UM_UserType));
                    } else {
                        setShouldShowSCPColumn(false);
                    }
                    fetchCompanyITPolicyNames(
                        singleOption.value,
                        selectedCompanyId || UM_CompanyID,
                        selectedScpId
                    );
                    console.log("Filtered options:", filteredOptions);
                } else {
                    setShowGroupTypeField(true);
                }
            } catch (error) {
                console.error('Error fetching enum options:', error);
            }
        };

        fetchEnumOptions();
    }, [UM_CompanyID, selectedCompanyId, selectedScpId]);

    const [machineTypesLoaded, setMachineTypesLoaded] = useState(false);

    useEffect(() => {
        const load = async () => {
            await fetchCompanyNameForSuperAdmin();
            await fetchMachineTypes();
            setMachineTypesLoaded(true);
        };
        load();
    }, []);

    useEffect(() => {
        if (isEditing && groupId && machineTypesLoaded) {
            fetchGroupDetails(groupId);
        }
    }, [isEditing, groupId, machineTypesLoaded]);

    const fetchGroupDetails = async (id) => {
        try {
            const response = await fetch(`${config.API_URL}/groupDetails/${id}`);
            if (!response.ok) throw new Error('Failed to fetch group details');
            const result = await response.json();
            console.log("result", result)
            if (result.success) {
                const data = result.data;
                setFormdata({
                    GRPM_GroupName: data.GRPM_GroupName,
                    GRPM_ITPolicyId: data.GRPM_ITPolicyId,
                    GRPM_GroupStatus: data.GRPM_GroupStatus,
                    GRPM_CompanyGrpId: data.GRPM_CompanyGrpId,
                    GRPM_CompanyID: data.GRPM_CompanyID,
                    GRPM_GroupType: data.GRPM_GroupType,
                    Company_Name: data.CM_CompanyName,
                    RLM_MachineType: '',
                    MNM_MenuName: [],
                });
                setOriginalGroupData({
                    GRPM_GroupName: data.GRPM_GroupName,
                    GRPM_ITPolicyId: data.GRPM_ITPolicyId,
                    GRPM_GroupStatus: data.GRPM_GroupStatus,
                    GRPM_CompanyGrpId: data.GRPM_CompanyGrpId,
                    GRPM_CompanyID: data.GRPM_CompanyID,
                    GRPM_GroupType: data.GRPM_GroupType,
                    Company_Name: data.CM_CompanyName,
                    SCPM_ID: data.SCPM_ID || '',
                    GroupRights: data.GroupRights.map((gr) => {
                        const machineTypeId = parseInt(gr.MachineTypeId);
                        const machineType = machineTypes.find(type => type.AppId === machineTypeId)?.AppName || '';
                        let groupRights = [];
                        if (machineTypeId === 1) {
                            groupRights = gr.Rights.map((r) => ({
                                type: 'submenu',
                                MNM_MenuID: r.MNM_MenuID,
                                SMNM_SubMenuID: r.SMNM_SubMenuID,
                                displayName: r.SMNM_SubMenuDisplay,
                            }));
                        } else {
                            groupRights = gr.Rights.map((r) => `${r.Id}-${r.Name}`);
                        }
                        return {
                            machineTypeId,
                            machineType,
                            groupRights,
                        };
                    }),
                });
                setSelectedSCP(data.SCPM_ID || '');
                setSelectedGroupTypeId(data.GRPM_GroupType);
                setShouldShowSCPColumn(data.GRPM_GroupType === 3 && parseInt(UM_UserType) !== 3);
                setSelectedCompanyId(data.GRPM_CompanyID);

                const builtTableList = data.GroupRights.map((gr) => {
                    const machineTypeId = parseInt(gr.MachineTypeId);
                    const machineType = machineTypes.find(type => type.AppId === machineTypeId)?.AppName || '';
                    let groupRights = [];
                    if (machineTypeId === 1) {
                        groupRights = gr.Rights.map((r) => ({
                            type: 'submenu',
                            MNM_MenuID: r.MNM_MenuID,
                            SMNM_SubMenuID: r.SMNM_SubMenuID,
                            displayName: r.SMNM_SubMenuDisplay,
                        }));
                    } else {
                        groupRights = gr.Rights.map((r) => `${r.Id}-${r.Name}`);
                    }
                    return {
                        machineTypeId,
                        machineType,
                        groupRights,
                    };
                });
                setTableList(builtTableList);

                fetchCompanyITPolicyNames(
                    data.GRPM_GroupType,
                    data.GRPM_CompanyID,
                    data.SCPM_ID
                );
                if (data.GRPM_GroupType === 3) {
                    fetchSCPData(data.GRPM_CompanyID, selectedScpId, parseInt(UM_UserType));
                }
            } else {
                //toast.error('Failed to load group details.');
            }
        } catch (error) {
            console.error('Error fetching group details:', error);
            //toast.error('Failed to load group details. Please try again.');
        }
    };

    const fetchMachineTypes = async () => {
        try {
            const response = await fetch(`${config.API_URL}/machines/${UM_GroupId}/${UM_UserType}`);
            const data = await response.json();
            if (data.success) {
                setMachineTypes(data.data);
            }
        } catch (error) {
            console.error('Error fetching machine types:', error);
            logAction('fetchMachineTypes(): Error fetching machine types', true);
            //toast.error("Failed to load machine types. Please try again.");
        }
    };

    const fetchSCPData = async (companyId, scpId, userType) => {
        try {
            const response = await fetch(
                `${config.API_URL}/scp-data/${companyId}/${scpId}/${userType}`
            );
            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            setScps(data);

            if (userType === 3 && Array.isArray(data) && data.length === 1) {
                const singleOption = data[0];
                setSelectedSCP(singleOption.SCPM_ID);
                setFormdata(prev => ({
                    ...prev,
                    SCPM_ID: singleOption.SCPM_ID
                }));
            }
        } catch (error) {
            console.error('Error fetching SCP data:', error);
            //toast.error("Failed to load SCP data. Please try again.");
        }
    };

    useEffect(() => {
        if (selectedScpId && parseInt(UM_UserType) === 3) {
            fetchSCPData(UM_CompanyID, selectedScpId, parseInt(UM_UserType));
        }
    }, [UM_CompanyID, selectedScpId, UM_UserType]);

    useEffect(() => {
        sessionStorage.setItem('UM_GroupId', UM_GroupId);
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
        sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
        sessionStorage.setItem('UM_UserId', UM_UserId);
        sessionStorage.setItem('UM_UserCode', UM_UserCode);
        sessionStorage.setItem('selectedScpId', selectedScpId);
        sessionStorage.setItem('UM_UserType', UM_UserType);
    }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId, UM_UserType]);

    const logAction = async (action, isError = false) => {
        try {
            const response = await fetch(`${config.API_URL}/api/log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ module: "GroupMaster:", action, userCode: UM_UserCode, isError, CM_CompanyName: CM_CompanyName }),
            });
            if (!response.ok) throw new Error('Failed to log action');
        } catch (error) {
            console.error('Error logging action:', error);
        }
    };

    const logAudit = async (module, message, oldValue = "", newValue = "", transactionDetails = []) => {
        const auditLogPayload = {
            AUTR_ScreenName: module,
            AUTR_OldValue: oldValue,
            AUTR_NewValue: newValue,
            AUTR_Message: message,
            AUTR_UserID: UM_UserId,
            AUTR_UserName: UM_UserCode,
            AUTR_AuditType: 5,
            AUTR_SCPID: selectedScpId,
            AUTR_CompanyGrpId: UM_CompanyGrpID,
            AUTR_CompanyID: UM_CompanyID,
            AUTR_CreatedBy: UM_UserId,
            insertAuditTransaction: transactionDetails.length > 0,
            transactionDetails
        };

        try {
            const response = await fetch(`${config.API_URL}/audit/log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(auditLogPayload),
            });
            if (!response.ok) throw new Error('Failed to log action');
        } catch (error) {
            console.error('Error logging action:', error);
        }
    };

    const fetchCompanyNameForSuperAdmin = async () => {
        logAction("fetchCompanyNameForSuperAdmin(): started");
        try {
            const response = await fetch(`${config.API_URL}/companynames`);
            const data = await response.json();
            if (data && data.length > 0) {
                setCompanyNames(data);
                logAction("fetchCompanyNameForSuperAdmin(): Company Names fetched successfully");
            } else {
                console.error('No company names found.');
                logAction("fetchCompanyNameForSuperAdmin(): Failed to fetch company names", true);

            }
        } catch (error) {
            logAction("fetchCompanyNameForSuperAdmin(): Error fetching company names", true);
            console.error('Error fetching company names:', error);

        }
    };

    const fetchCompanyITPolicyNames = async (groupTypeId, companyId, selectedscpid) => {
        logAction(`fetchCompanyITPolicyNames(${groupTypeId}, ${companyId}): started`);
        try {
            const response = await fetch(`${config.API_URL}/ITPolicy/${groupTypeId}/${companyId}/${selectedscpid}`);
            const data = await response.json();
            if (data.policyNames) {
                setCompanyName(data.policyNames);
                logAction("fetchCompanyITPolicyNames(): Policy Names fetched successfully");
            } else {
                console.error('Error fetching policy names:', data.message);
                logAction("fetchCompanyITPolicyNames(): Failed to fetch policy names", true);
                //toast.error('Error fetching policy names. Please try again.');
            }
        } catch (error) {
            console.error('Error fetching policy names:', error);
            logAction("fetchCompanyITPolicyNames(): Error fetching policy names", true);
            //toast.error('Error fetching policy names. Please try again.');
        }
    };

    const handleSCPSelect = (option) => {
        const selectedValue = option ? option.value : '';
        setSelectedSCP(selectedValue);

        fetchCompanyITPolicyNames(
            selectedGroupTypeId,
            formdata.GRPM_CompanyID || UM_CompanyID,
            selectedValue
        );
        if (selectedValue && emptyFields.includes('scpname')) {
            setEmptyFields(prev => prev.filter(f => f !== 'scpname'));
        }
    };

    const handleChange = (option, { name }) => {
        const value = option ? option.value : '';
        let fieldKey;
        let sanitizedValue = value;

        if (name === 'GRPM_GroupName') {
            fieldKey = 'groupname';
            sanitizedValue = value.replace(/[^a-zA-Z0-9\s_-]/g, '');
            sanitizedValue = sanitizedValue.replace(/[\s_-]{2,}/g, match => match[0]);
            // Limit to 45 characters
            sanitizedValue = sanitizedValue.slice(0, 45);

            // Ignore trailing spaces during live validation; trim happens on save.
            const validationValue = sanitizedValue.replace(/\s+$/, '');
            const firstCharValid = validationValue.length === 0 || /^[a-zA-Z0-9]/.test(validationValue[0]);
            const lastCharValid = validationValue.length === 0 || /[a-zA-Z0-9]$/.test(validationValue[validationValue.length - 1]);

            if (!firstCharValid || !lastCharValid) {
                setIsGroupNameValid(false);
                setMessage('First and last character must be alphanumeric');
            } else {
                setIsGroupNameValid(true);
                setMessage('');
            }
        }
        else if (name === 'GRPM_ITPolicyId') {
            fieldKey = 'policyname';
        } else if (name === 'GRPM_GroupStatus') {
            fieldKey = 'status';
        } else if (name === 'RLM_MachineType') {
            fieldKey = 'machinetype';
        } else if (name === 'GRPM_GroupType') {
            fieldKey = 'grouptype';
        }

        setFormdata({
            ...formdata,
            [name]: sanitizedValue,
        });

        if (name === 'RLM_MachineType') {
            setSelectedGroupRights([]);
            setEditingRowIndex(null);
        }

        if (fieldKey && sanitizedValue && emptyFields.includes(fieldKey)) {
            setEmptyFields(prev => prev.filter(f => f !== fieldKey));
        }
    };

    const resetOnGroupTypeChange = () => {
        setFormdata(prev => ({
            ...prev,
            GRPM_ITPolicyId: null,
            RLM_MachineType: ''
        }));

        setSelectedSCP('');
        setShouldShowSCPColumn(false);

        setSelectedGroupRights([]);
        setTableList([]);
        setMenuData([]);
        setAllAvailableKeys([]);

        setEmptyFields([]);
        setIsTreeView(false);
        setEditingRowIndex(null);
    };

    const resetOnCompanyChange = () => {
        logAction("resetOnCompanyChange(): Started");

        // Only remove 'companyname' — do NOT clear everything
        setEmptyFields(prev => prev.filter(f => f !== 'companyname'));

        setFormdata(prev => ({
            ...prev,
            // KEEP company info
            GRPM_CompanyGrpId: prev.GRPM_CompanyGrpId,
            GRPM_CompanyID: prev.GRPM_CompanyID,
            Company_Name: prev.Company_Name,

            // RESET dependent fields
            GRPM_ITPolicyId: null,
            GRPM_GroupStatus: 1,
            GRPM_GroupType: '',
            MNM_MenuName: [],
            RLM_MachineType: ''
        }));

        // Reset selections
        setSelectedGroupTypeId('');
        setSelectedSCP('');
        setShouldShowSCPColumn(false);

        // Reset dependent datasets
        setSelectedGroupRights([]);
        setTableList([]);
        setMenuData([]);
        setAllAvailableKeys([]);

        // Reset company-related UI lists
        setCompanyName([]);

        // Reset UI validation & mode
        setIsTreeView(false);
        setEditingRowIndex(null);

        // Reset edit state
        setOriginalGroupData(null);

        logAction("resetOnCompanyChange(): Completed");
    };


    const handleCompanySelect = (option) => {
        const value = option ? option.value : '';
        const selectedCompany = companyNames.find(company =>
            company?.CM_CompanyName?.trim().toLowerCase() === value.trim().toLowerCase()
        );

        if (!selectedCompany) {
            setSelectedCompanyId('');
            resetOnCompanyChange();

            setFormdata(prev => ({
                ...prev,
                Company_Name: '',
                GRPM_CompanyGrpId: '',
                GRPM_CompanyID: ''
            }));
            return;
        }

        const companyID = selectedCompany.CM_ID || '';
        const companyGrpID = selectedCompany.CM_CompanyGrpId || '';

        // 🔴 IMPORTANT: Reset dependent data FIRST
        resetOnCompanyChange();

        // Set new company
        setSelectedCompanyId(companyID);

        setFormdata(prev => ({
            ...prev,
            Company_Name: value,
            GRPM_CompanyGrpId: companyGrpID,
            GRPM_CompanyID: companyID
        }));

        // Fetch SCP for new company
        fetchSCPData(companyID || UM_CompanyID, selectedScpId, parseInt(UM_UserType));

        if (value && emptyFields.includes('companyname')) {
            setEmptyFields(prev => prev.filter(f => f !== 'companyname'));
        }
    };


    const handlePolicyName = async () => {
        logAction("handlePolicyName(): Started");
        if (!formdata.GRPM_ITPolicyId) {
            setEmptyFields(prev => [...prev, 'policyname']);
            showToast('error', "Please select policy.");
            setTimeout(() => setMessage(''), 2000);
            logAction("handlePolicyName(): Policy Name empty", true);
            return;
        }
        try {
            const response = await fetch(`${config.API_URL}/CITPM_PolicyNames/${formdata.GRPM_ITPolicyId}`);
            const data = await response.json();
            if (response.ok) {
                setSelectedPolicyDetails(data.data);
                setShowModal(true);
                logAction(`handlePolicyName(): Policy details opened for ${formdata.GRPM_ITPolicyId}`);
            } else {
                console.error('Error fetching policy details:', data.error);
                logAction(`handlePolicyName(): Failed to fetch policy details for ${formdata.GRPM_ITPolicyId}`, true);
                //toast.error("Failed to load policy details.");
            }
        } catch (error) {
            console.error('Error fetching policy details:', error);
            logAction(`handlePolicyName(): Error fetching policy details for ${formdata.GRPM_ITPolicyId}`, true);
            //toast.error("Failed to load policy details.");
        }
    };

    const handlePoolButtonClick = (selectedRow) => {
        logAction("handlePoolButtonClick(): Started");
        setSelectedMachineType(selectedRow.machineType);
        const submenuDisplayNames = [];

        if (selectedRow.machineTypeId === 1) {
            selectedRow.groupRights.forEach(item => {
                if (item && typeof item === "object" && item.type === "submenu") {
                    let foundName = item.displayName;
                    if (menuData.length > 0) {
                        for (const menu of menuData) {
                            const subMenu = menu.subMenus.find(sub => String(sub.SMNM_Id) === String(item.SMNM_SubMenuID));
                            if (subMenu) {
                                foundName = subMenu.SMNM_SubMenuDisplay;
                                break;
                            }
                        }
                    }
                    submenuDisplayNames.push(foundName);
                }
            });
        } else {
            selectedRow.groupRights.forEach(key => {
                const [, ...roleNameParts] = key.split('-');
                const roleName = roleNameParts.join('-');
                submenuDisplayNames.push(roleName);
            });
        }

        const RLM_MenuOptions = submenuDisplayNames.map(name => ({
            subMenuOptions: [name]
        }));

        setPopupSelectedSubMenus(RLM_MenuOptions);
        setShowPopup(true);
        logAction(`handlePoolButtonClick(): Popup opened with group rights. MachineType = ${selectedRow.machineType}`);
    };

    const initialFormData = {
        GRPM_GroupName: '',
        GRPM_ITPolicyId: '',
        GRPM_GroupStatus: 1,
        GRPM_CompanyGrpId: '',
        GRPM_CompanyID: '',
        MNM_MenuName: [],
        RLM_MachineType: '',
        GRPM_GroupType: '',
    };

    const handleCancel = () => {
        logAction("handleCancel(): Started");
        if (editingRowIndex !== null) {
            setShowUpdateRequired(true);

            return;
        }

        // Preserve original data if in edit mode
        if (isEditing && originalGroupData) {
            setFormdata({
                ...originalGroupData,
                GRPM_ITPolicyId: null,     // 🔴 Reset IT Policy
                GRPM_GroupStatus: 1         // 🔴 Reset status to Active
            });
            setSelectedGroupRights(originalGroupData.selectedGroupRights || []);
            setTableList(originalGroupData.tableList || []);
            setSelectedGroupTypeId(originalGroupData.GRPM_GroupType);
            //setSelectedCompanyId(originalGroupData.Company_Name);
            //setSelectedSCP(originalGroupData.SCP_Name || '');
            setShouldShowSCPColumn(originalGroupData.GRPM_GroupType === 3);

            // Re-fetch policy names if needed
            if (originalGroupData.GRPM_GroupType !== 3) {
                fetchCompanyITPolicyNames(
                    originalGroupData.GRPM_GroupType,
                    selectedCompanyId || UM_CompanyID,
                    originalGroupData.SCP_Name
                );
            }
        } else {
            // Full reset only if not in edit mode
            setMessage('');
            setFormdata({ ...initialFormData, Company_Name: '' });
            if (parseInt(UM_UserType) !== 3) {
                setSelectedSCP('');
            }

            setSelectedGroupRights([]);
            setTableList([]);
            setEmptyFields([]);
            setAllAvailableKeys([]);
            setIsTreeView(false);
            setMenuData([]);
            setEditingRowIndex(null);
            setSelectedCompanyId('');
            setCompanyName([]);

            setSelectedGroupTypeId(null);
            setOriginalGroupData(null);
            if (parseInt(UM_UserType) !== 1) {
                setShouldShowSCPColumn(false);
                setScps([]);
            }
        }

        // Handle single group type case (common for both modes)
        if (groupTypeOptions.length === 1) {
            const single = groupTypeOptions[0].value;
            setSelectedGroupTypeId(single);
            setFormdata(prev => ({ ...prev, GRPM_GroupType: single }));
            fetchCompanyITPolicyNames(single, UM_CompanyID, selectedScpId);
        }

        logAction("handleCancel(): Completed");
    };

    useEffect(() => {
        // when moving from edit → create (param removed)
        if (!groupId) {
            handleCancel();
        }
    }, [groupId]);


    const handleEditRow = (index) => {
        logAction("handleEditRow(): Started");
        const row = tableList[index];
        setFormdata(prev => ({ ...prev, RLM_MachineType: row.machineTypeId }));

        if (row.machineTypeId === 1) {
            const treeKeys = row.groupRights
                .filter(gr => gr.type === "submenu")
                .map(gr => `submenu-${gr.SMNM_SubMenuID}-${gr.displayName}`);
            setSelectedGroupRightsWithValidation(treeKeys);
        } else {
            setSelectedGroupRightsWithValidation([...row.groupRights]);
        }

        setEditingRowIndex(index);
        logAction("handleEditRow(): Row selected for editing");
    };

    const setSelectedGroupRightsWithValidation = (keys) => {
        setSelectedGroupRights(keys);
        if (keys.length > 0 && emptyFields.includes('grouprights')) {
            setEmptyFields(prev => prev.filter(f => f !== 'grouprights'));
        }
    };

    const handleAddRow = () => {
        logAction("handleAddRow(): Started");
        let emptyFieldsArray = [];
        if (!formdata.RLM_MachineType) {
            emptyFieldsArray.push('machinetype');
        }
        if (!selectedGroupRights || selectedGroupRights.length === 0) {
            emptyFieldsArray.push('grouprights');
        }
        if (emptyFieldsArray.length > 0) {
            setEmptyFields(emptyFieldsArray);
            return;
        }

        if (formdata.RLM_MachineType === 1) {
            const selectedSubMenus = selectedGroupRights
                .filter(gr => typeof gr === 'string' && gr.startsWith('submenu'))
                .map(gr => {
                    const parts = gr.split('-');
                    return {
                        id: parseInt(parts[1]),
                        name: parts.slice(2).join('-')
                    };
                });

            const invalidPairs = [
                [23, 24],
                [23, 28],
                [24, 28],
                [25, 29],
                [27, 29],
            ];

            for (const [a, b] of invalidPairs) {
                const subA = selectedSubMenus.find(sm => sm.id === a);
                const subB = selectedSubMenus.find(sm => sm.id === b);

                if (subA && subB) {
                    console.warn(`❌ Invalid pair found: ${subA.name}, ${subB.name}`);
                    showToast('error', `You cannot select both ${subA.name} and ${subB.name} in same Group.`);
                    logAction(
                        `handleAddRow(): Invalid submenu combination (${subA.name}, ${subB.name}) selected`,
                        true
                    );
                    return;
                }
            }
        }

        const newRow = {
            machineTypeId: formdata.RLM_MachineType,
            machineType: machineTypes.find(type => type.AppId == formdata.RLM_MachineType)?.AppName || '',
            groupRights: formdata.RLM_MachineType === 1
                ? selectedGroupRights.map(gr => {
                    if (typeof gr === 'string') {
                        const parts = gr.split('-');
                        if (parts[0] !== 'submenu') {
                            console.warn(`handleAddRow: Invalid group right format for machineTypeId 1: ${gr}`);
                            return null;
                        }
                        return {
                            type: "submenu",
                            MNM_MenuID: menuData.find(menu =>
                                menu.subMenus.some(sub => String(sub.SMNM_Id) === parts[1])
                            )?.MNM_Id || null,
                            SMNM_SubMenuID: parts[1],
                            displayName: parts.slice(2).join('-')
                        };
                    }
                    return gr;
                }).filter(gr => gr !== null)
                : [...selectedGroupRights]
        };

        let updatedTableList;
        if (editingRowIndex !== null) {
            updatedTableList = [...tableList];
            updatedTableList[editingRowIndex] = newRow;
            logAction("handleAddRow(): Row updated in table");
        } else {
            if (tableList.some(row => row.machineTypeId == formdata.RLM_MachineType)) {
                showToast('error', "This machine type is already added.");
                logAction(`handleAddRow(): Attempted to add duplicate machine type ${formdata.RLM_MachineType}`, true);
                return;
            }
            updatedTableList = [...tableList, newRow];
            logAction("handleAddRow(): Row added to table");
        }

        setTableList(updatedTableList);
        setFormdata(prev => ({ ...prev, RLM_MachineType: '' }));
        setSelectedGroupRights([]);
        setEditingRowIndex(null);
        if (updatedTableList.length > 0 && emptyFields.includes('grouprights')) {
            setEmptyFields(prev => prev.filter(f => f !== 'grouprights'));
        }
    };

    const handleRemoveClick = (index, machinetype) => {
        setRowToRemove(index);
        setSelectedMachineType(machinetype);
        setRemoveConfirmationModal(true);
    };

    const confirmRemoveRow = () => {
        if (rowToRemove !== null) {
            const updatedTableList = [...tableList];
            updatedTableList.splice(rowToRemove, 1);
            setTableList(updatedTableList);

            if (editingRowIndex === rowToRemove) {
                setEditingRowIndex(null);
                setFormdata(prev => ({ ...prev, RLM_MachineType: '' }));
                setSelectedGroupRights([]);
            }
        }
        setRemoveConfirmationModal(false);
        setRowToRemove(null);
    };

    const cancelRemoveRow = () => {
        setRemoveConfirmationModal(false);
        setRowToRemove(null);
    };

  const handleSubmit = async (e) => {
        logAction("handleSubmit(): Started");
        setLoading(true);
        e.preventDefault();
        const trimmedGroupName = (formdata.GRPM_GroupName || '').trim();

        if (editingRowIndex !== null) {
            setShowUpdateRequired(true);
            setLoading(false);
            return;
        }

        const regex = /^(?!.*(?:[-_ @]){2})[a-zA-Z0-9][-_ @a-zA-Z0-9]*[a-zA-Z0-9]$/;
        let emptyFieldsArray = [];

        if (parseInt(UM_UserType) === 0 && formdata.GRPM_CompanyGrpId === '') {
            emptyFieldsArray.push('companyname');
        }
        if (trimmedGroupName === '') {
            emptyFieldsArray.push('groupname');
        }
        if (!formdata.GRPM_ITPolicyId) {
            emptyFieldsArray.push('policyname');
        }
        if (!formdata.GRPM_GroupStatus) {
            emptyFieldsArray.push('status');
        }

        if (showGroupTypeField && !formdata.GRPM_GroupType) {
            emptyFieldsArray.push('grouptype');
        }
        if (shouldShowSCPColumn && !selectedSCP) {
            emptyFieldsArray.push('scpname');
        }

        if (emptyFieldsArray.length > 0) {
            setEmptyFields(emptyFieldsArray);
            logAction("handleSubmit(): Form submission failed due to missing fields", true);
            setLoading(false);
            return;
        }

        if (/^\s/.test(formdata.GRPM_GroupName || '')) {
            setIsGroupNameValid(false);
            setMessage('First character must not be a space');
            logAction(`handleSubmit(): Invalid group name (starts with space): ${formdata.GRPM_GroupName}`, true);
            setLoading(false);
            return;
        }

        if (!trimmedGroupName.match(regex)) {
            logAction(`handleSubmit(): Invalid group name ${trimmedGroupName}`, true);
            setLoading(false);
            return;
        }

        if (tableList.length === 0) {
            toast.error(`At least one machine right is required to save this Group : ${trimmedGroupName}.`);
            setLoading(false);
            return;
        }

        if (parseInt(initialFormData.GRPM_GroupStatus) === 1 && parseInt(formdata.GRPM_GroupStatus) !== 1) {
            try {
                const response = await fetch(`${config.API_URL}/groupstatus/${groupId}`);
                const result = await response.json();

                if (response.status === 200 && result.activeUserCount > 0) {
                    toast.error(`You cannot inactivate the Group : ${trimmedGroupName} because a reference exists in the User Master.`);
                    setLoading(false);
                    return;
                } else if (response.status === 404) {
                    console.log('Group not found.');
                }
            } catch (error) {
                console.error('Error fetching group status:', error);
                setLoading(false);
                return { error: 'Error fetching group status.' };
            }
        }

        try {
            let shouldCheckDuplicate = !isEditing || trimmedGroupName !== originalGroupData?.GRPM_GroupName;
            if (shouldCheckDuplicate) {
                const checkResponse = await fetch(`${config.API_URL}/checkGroupName`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        groupName: trimmedGroupName,
                        companyID: formdata.GRPM_CompanyID || UM_CompanyID,
                        groupType: selectedGroupTypeId,
                        selectedScpId: selectedSCP || selectedScpId
                    }),
                });

                if (!checkResponse.ok) throw new Error('Failed to check duplicate group name');

                const checkData = await checkResponse.json();
                if (checkData.exists) {
                    toast.error(`Group : ${trimmedGroupName} already exists.`);
                    logAction(`handleSubmit(): Duplicate group name ${trimmedGroupName}`, true);
                    setLoading(false);
                    return;
                }
            }

            const machineType1Row = tableList.find(row => row.machineTypeId === 1);
            if (machineType1Row) {
                const selectedSubMenus = machineType1Row.groupRights
                    .filter(k => k.type === "submenu")
                    .map(k => ({
                        id: parseInt(k.SMNM_SubMenuID),
                        name: k.displayName
                    }));

                const invalidPairs = [
                    [23, 24],
                    [23, 28],
                    [24, 28],
                    [25, 29],
                    [27, 29],
                ];

                for (const [a, b] of invalidPairs) {
                    const subA = selectedSubMenus.find(sm => sm.id === a);
                    const subB = selectedSubMenus.find(sm => sm.id === b);

                    if (subA && subB) {
                        toast.error(`You cannot select both ${subA.name} and ${subB.name} in same Group.`);
                        logAction(`handleSubmit(): Invalid submenu combination (${subA.name}, ${subB.name}) selected`, true);
                        setLoading(false);
                        return;
                    }
                }
            }

            const payload = {
                ...(isEditing && { GRPM_ID: groupId }),
                GRPM_GroupName: trimmedGroupName,
                GRPM_ITPolicyId: formdata.GRPM_ITPolicyId,
                GRPM_GroupStatus: formdata.GRPM_GroupStatus,
                GRPM_CompanyGrpId: formdata.GRPM_CompanyGrpId || UM_CompanyGrpID,
                GRPM_CompanyID: formdata.GRPM_CompanyID || UM_CompanyID,
                GRPM_GroupType: formdata.GRPM_GroupType,
                SCPM_ID: selectedSCP || selectedScpId,
                [isEditing ? 'UpdatedBy' : 'CreatedBy']: UM_UserId,
                [isEditing ? 'UpdatedByUserCode' : 'CreatedByUserCode']: UM_UserCode,

                GroupRights: tableList.map(row => {
                    if (row.machineTypeId === 1) {
                        const rights = row.groupRights
                            .filter(k => k.type === "submenu")
                            .map(k => ({
                                MNM_MenuID: k.MNM_MenuID,
                                SMNM_SubMenuID: k.SMNM_SubMenuID
                            }));
                        return { MachineTypeId: row.machineTypeId, Rights: rights };
                    } else {
                        const rights = row.groupRights.map(key => {
                            const parts = key.split('-');
                            if (parts.length < 2) {
                                logAction(`handleSubmit(): Invalid key format: ${key}`, true);
                                return null;
                            }
                            const [id, ...nameParts] = parts;
                            return { Id: id, Name: nameParts.join('-') };
                        }).filter(right => right !== null);

                        return { MachineTypeId: row.machineTypeId, Rights: rights };
                    }
                }).filter(row => row.Rights.length > 0),
            };

            const groupTypeName = groupTypeOptions.find(opt => opt.value === formdata.GRPM_GroupType)?.label || '-';
            const policyName = companyName.find(policy => policy.CITPM_PolicyID === formdata.GRPM_ITPolicyId)?.CITPM_PolicyName || '-';
            const statusName = formdata.GRPM_GroupStatus === 1 ? 'Active' : 'Inactive';
            const scpName = scps.find(scp => scp.SCPM_ID === (selectedSCP || selectedScpId))?.SCPM_Name || '-';
            const companyNameValue = formdata.Company_Name || '-';

            const groupRightsNames = tableList.map(row => ({
                MachineType: row.machineType,
                Rights: row.machineTypeId === 1
                    ? row.groupRights.map(gr => gr.displayName).join(', ')
                    : row.groupRights.map(key => {
                        const [, ...nameParts] = key.split('-');
                        return nameParts.join('-');
                    }).join(', ')
            }));

            const response = await fetch(`${config.API_URL}/${isEditing ? 'updateGroupData' : 'saveGroupData'}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || `Failed to ${isEditing ? 'update' : 'save'} group data`);
            }

            toast.success(
                `Group : ${trimmedGroupName} ${isEditing ? 'updated' : 'saved'} successfully.`,
                {
                    onClose: () => {
                        setLoading(false);
                        handleCancel();
                        navigate("/dashboard/GroupM");
                    }
                }
            );

            logAction(`handleSubmit(): Group ${trimmedGroupName} ${isEditing ? 'updated' : 'saved'}`);

            let transactionDetails = [
                {
                    AUTRN_ParamererName: "Group Name",
                    AUTRN_OldValue: isEditing ? originalGroupData?.GRPM_GroupName || "-" : "-",
                    AUTRN_NewValue: trimmedGroupName
                },
                {
                    AUTRN_ParamererName: "Group Type",
                    AUTRN_OldValue: isEditing ? groupTypeOptions.find(opt => opt.value === originalGroupData?.GRPM_GroupType)?.label || "-" : "-",
                    AUTRN_NewValue: groupTypeName
                },
                {
                    AUTRN_ParamererName: "Policy Name",
                    AUTRN_OldValue: isEditing ? companyName.find(policy => policy.CITPM_PolicyID === originalGroupData?.GRPM_ITPolicyId)?.CITPM_PolicyName || "-" : "-",
                    AUTRN_NewValue: policyName
                },
                {
                    AUTRN_ParamererName: "Status",
                    AUTRN_OldValue: isEditing ? (originalGroupData?.GRPM_GroupStatus === 1 ? 'Active' : 'Inactive') : "-",
                    AUTRN_NewValue: statusName
                },
                {
                    AUTRN_ParamererName: "SCP Name",
                    AUTRN_OldValue: isEditing ? scps.find(scp => scp.SCPM_ID === originalGroupData?.SCPM_ID)?.SCPM_Name || "-" : "-",
                    AUTRN_NewValue: scpName
                },
                {
                    AUTRN_ParamererName: "Group Rights",
                    AUTRN_OldValue: isEditing && originalGroupData ? JSON.stringify(originalGroupData.GroupRights.flatMap(row =>
                        row.machineTypeId === 1
                            ? row.groupRights.map(gr => ({
                                "MachineType": row.machineType,
                                "Rights": gr.displayName
                            }))
                            : row.groupRights.map(key => {
                                const [, ...nameParts] = key.split('-');
                                return {
                                    "MachineType": row.machineType,
                                    "Rights": nameParts.join('-')
                                };
                            })
                    )) : "-",
                    AUTRN_NewValue: JSON.stringify(groupRightsNames.flatMap(row =>
                        row.Rights.split(', ').map(right => ({
                            "MachineType": row.MachineType,
                            "Rights": right
                        }))
                    ))
                }
            ];

            if (parseInt(UM_UserType) === 0) {
                transactionDetails.push({
                    AUTRN_ParamererName: "Company Name",
                    AUTRN_OldValue: isEditing ? originalGroupData?.Company_Name || "-" : "-",
                    AUTRN_NewValue: companyNameValue
                });
            }

            await logAudit(
                "Group Master",
                `Group : ${trimmedGroupName} ${isEditing ? 'updated' : 'saved'} successfully`,
                "-",
                `${trimmedGroupName}`,
                transactionDetails
            );

        } catch (error) {
            console.error(`Error ${isEditing ? 'updating' : 'submitting'} form data:`, error);
            logAction(`handleSubmit(): Error ${isEditing ? 'updating' : 'saving'} ${trimmedGroupName}: ${error.message}`, true);
            setLoading(false);
        }
    };

    const availableMachineTypes = machineTypes.map(type => ({
        value: type.AppId,
        label: type.AppName,
        disabled: editingRowIndex === null && tableList.some(row => row.machineTypeId == type.AppId)
    }));

    const companyNameOptions = companyNames.map(company => ({
        value: company.CM_CompanyName,
        label: company.CM_CompanyName
    }));

    const groupTypeSelectOptions = groupTypeOptions.map(option => ({
        value: option.value,
        label: option.label
    }));

    const policyNameOptions = Array.isArray(companyName) ? companyName.map(policy => ({
        value: policy.CITPM_PolicyID,
        label: policy.CITPM_PolicyName
    })) : [];

    const scpOptions = scps.map(scp => ({
        value: scp.SCPM_ID,
        label: scp.SCPM_Name
    }));

    useEffect(() => {
        if (
            availableMachineTypes.length === 1 &&
            tableList.length === 0 &&
            !formdata.RLM_MachineType
        ) {
            const single = availableMachineTypes[0];

            // Set formdata properly
            setFormdata(prev => ({
                ...prev,
                RLM_MachineType: single.value
            }));
        }
    }, [availableMachineTypes, tableList]);

    const isRowEditing = editingRowIndex !== null;


    return (
        <React.Fragment>
            <form onSubmit={handleSubmit} autoComplete="off">
                <div className='main_container'>
                    <h3 className="formHeading">  Group Master</h3>
                    <div style={{ marginLeft: '-5px' }}>
                        <div className='row' >
                            <div className='col-md-5'>
                                {showSelectCompany && (
                                    <div className='col-sm-10 m-2'>
                                        <div className="label-input-container">
                                            <label className='form-label'>Company Name {emptyFields.includes('companyname') && <span style={{ color: 'red' }}> *</span>}</label>
                                            <div className='select-container'>
                                                <Select
                                                    className='routing_select-box'
                                                    options={companyNameOptions}
                                                    value={companyNameOptions.find(opt => opt.value === formdata.Company_Name) || null}
                                                    onChange={handleCompanySelect}
                                                    placeholder="--Select--"
                                                    onMenuOpen={() => handleSelectOpen('Company_Name')}
                                                    onMenuClose={handleSelectClose}
                                                    maxMenuHeight="140px"
                                                    styles={{
                                                        singleValue: (provided) => ({
                                                            ...provided,
                                                            color: '#6c757d',           // ← exactly the same as disabled input
                                                        }),
                                                        // Optional but recommended: also fix placeholder color when disabled
                                                        placeholder: (provided) => ({
                                                            ...provided,
                                                            color: '#6c757d',
                                                        }),
                                                        // Optional: make sure the control background matches too
                                                        control: (provided, state) => ({
                                                            ...provided,
                                                            backgroundColor: state.isDisabled ? '#f2f2f2' : provided.backgroundColor,
                                                            borderColor: state.isDisabled ? '#ced4da' : provided.borderColor,
                                                        })
                                                    }}
                                                    isDisabled={isEditing || isRowEditing}
                                                    components={{ SingleValue: CustomSingleValue }}
                                                />
                                                <div className='icon-container_list myList'>
                                                    <i>
                                                        {isSelectOpen === 'Company_Name' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                                                    </i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className='col-sm-10 m-2'>
                                    <label className='form-label'>Group Name{emptyFields.includes('groupname') && <span style={{ color: 'red' }}> *</span>}</label>
                                    <input
                                        type="text"
                                        name="GRPM_GroupName"
                                        className='form-input'
                                        value={formdata.GRPM_GroupName}
                                        onChange={(e) => handleChange({ value: e.target.value }, { name: 'GRPM_GroupName' })}
                                        pattern="[a-zA-Z0-9_-]*[a-zA-Z0-9]"
                                        style={
                                            isEditing
                                                ? {
                                                    backgroundColor: "#f2f2f2",
                                                    color: "#6c757d",
                                                }
                                                : {}
                                        }

                                        disabled={isRowEditing || isEditing}
                                    />
                                    {!isGroupNameValid && <span style={{ color: 'red' }}>{message}</span>}
                                </div>
                                {showGroupTypeField && (
                                    <div className='col-sm-12 m-2 d-flex'>
                                        <div className='col-sm-10'>
                                            <label className='form-label'>
                                                Group Type {emptyFields.includes('grouptype') && <span style={{ color: 'red' }}> *</span>}
                                            </label>
                                            <div className='select-container_list'>
                                                <Select
                                                    className='routing_select-box'
                                                    options={groupTypeSelectOptions}
                                                    styles={{
                                                        singleValue: (provided) => ({
                                                            ...provided,
                                                            color: '#6c757d',           // ← exactly the same as disabled input
                                                        }),
                                                        // Optional but recommended: also fix placeholder color when disabled
                                                        placeholder: (provided) => ({
                                                            ...provided,
                                                            color: '#6c757d',
                                                        }),
                                                        // Optional: make sure the control background matches too
                                                        control: (provided, state) => ({
                                                            ...provided,
                                                            backgroundColor: state.isDisabled ? '#f2f2f2' : provided.backgroundColor,
                                                            borderColor: state.isDisabled ? '#ced4da' : provided.borderColor,
                                                        })
                                                    }}
                                                    value={groupTypeSelectOptions.find(opt => opt.value === formdata.GRPM_GroupType) || null}
                                                    onChange={(option) => {
                                                        const selectedValue = option ? option.value : '';

                                                        // 🔴 RESET dependent data FIRST
                                                        resetOnGroupTypeChange();

                                                        // Set Group Type
                                                        handleChange(option, { name: 'GRPM_GroupType' });
                                                        setSelectedGroupTypeId(selectedValue);

                                                        // SCP visibility
                                                        setShouldShowSCPColumn(parseInt(selectedValue) === 3);

                                                        const companyIdToUse = selectedCompanyId || UM_CompanyID;

                                                        // Fetch data based on new Group Type
                                                        fetchSCPData(companyIdToUse, selectedScpId, parseInt(UM_UserType));

                                                        if (parseInt(selectedValue) !== 3) {
                                                            fetchCompanyITPolicyNames(
                                                                selectedValue,
                                                                companyIdToUse,
                                                                selectedScpId
                                                            );
                                                        } else {
                                                            setCompanyName([]);
                                                        }
                                                    }}

                                                    components={{ SingleValue: CustomSingleValue }}
                                                    placeholder="--Select--"
                                                    onMenuOpen={() => handleSelectOpen('GRPM_GroupType')}
                                                    onMenuClose={handleSelectClose}
                                                    maxMenuHeight="140px"
                                                    isDisabled={(parseInt(UM_UserType) === 0 && !selectedCompanyId) || isEditing || isRowEditing}
                                                />
                                                <div className='routing_icon-container '
                                                    style={{

                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}>
                                                    <i>
                                                        {isSelectOpen === 'GRPM_GroupType' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                                                    </i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {loading && (
                                    <div style={{
                                        position: 'fixed', // Sit on top of the page content
                                        left: 0,
                                        top: 0,
                                        width: '100%', // Full width
                                        height: '100%', // Full height
                                        zIndex: 1000 // Sit on top of the other elements
                                    }} />
                                )}

                                {shouldShowSCPColumn && (
                                    <div className='col-sm-10 m-2'>
                                        <label className='form-label'>
                                            SCP Name {emptyFields.includes('scpname') && <span style={{ color: 'red' }}> *</span>}
                                        </label>
                                        <div className='select-container'>
                                            <Select
                                                className='routing_select-box'
                                                options={scpOptions}
                                                value={scpOptions.find(opt => opt.value === selectedSCP) || null}
                                                onChange={handleSCPSelect}
                                                placeholder="--Select--"
                                                onMenuOpen={() => handleSelectOpen('SCP_Name')}
                                                onMenuClose={handleSelectClose}
                                                maxMenuHeight="140px"
                                                isDisabled={isRowEditing || isEditing}
                                                components={{ SingleValue: CustomSingleValue }}
                                            />
                                            <div className='icon-container_list myList'>
                                                <i>
                                                    {isSelectOpen === 'SCP_Name' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                                                </i>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className='col-sm-12 m-2 d-flex'>
                                    <div className='col-sm-10'>
                                        <label className='form-label'>Policy Name{emptyFields.includes('policyname') && <span style={{ color: 'red' }}> *</span>}</label>
                                        <div className='select-container'>
                                            <Select
                                                className='routing_select-box'
                                                options={policyNameOptions}
                                                value={policyNameOptions.find(opt => opt.value === formdata.GRPM_ITPolicyId) || null}
                                                onChange={(option) => handleChange(option, { name: 'GRPM_ITPolicyId' })}
                                                placeholder="--Select--"
                                                onMenuOpen={() => handleSelectOpen('GRPM_ITPolicyId')}
                                                onMenuClose={handleSelectClose}
                                                maxMenuHeight="140px"
                                                components={{ SingleValue: CustomSingleValue }}
                                                isDisabled={
                                                    (parseInt(UM_UserType) === 0 && !selectedGroupTypeId) ||
                                                    (parseInt(selectedGroupTypeId) === 3 && !selectedSCP) || isRowEditing}

                                            />
                                            <div className='icon-container_list myList'
                                                style={
                                                    parseInt(UM_UserType) === 3
                                                        ? undefined
                                                        : {

                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                        }
                                                }
                                            >
                                                <i>
                                                    {isSelectOpen === 'GRPM_ITPolicyId' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                                                </i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-1 ms-3'>
                                        <img src={Icon9} alt="Pool" onClick={handlePolicyName} title='Details' className='policy_bt' style={{ cursor: 'pointer', width: '22px', height: '17px', marginTop: '41px' }} />
                                    </div>
                                </div>

                                <div className="col-sm-10 m-2">
                                    <div className="label-input-container">
                                        <label>Machine Type{emptyFields.includes('machinetype') && <span style={{ color: 'red' }}> *</span>}</label>
                                        <div className='select-container'>
                                            <Select
                                                className='routing_select-box'
                                                options={availableMachineTypes}
                                                value={availableMachineTypes.find(opt => opt.value === formdata.RLM_MachineType) || null}
                                                onChange={(option) => handleChange(option, { name: 'RLM_MachineType' })}
                                                placeholder="--Select--"
                                                onMenuOpen={() => handleSelectOpen('RLM_MachineType')}
                                                onMenuClose={handleSelectClose}
                                                maxMenuHeight="140px"
                                                isDisabled={
                                                    availableMachineTypes.length === 1 ||
                                                    !selectedGroupTypeId || isRowEditing
                                                }
                                                isOptionDisabled={(option) => option.disabled}
                                                components={{ SingleValue: CustomSingleValue }}
                                            />
                                            <div className='icon-container_list myList'
                                                style={{

                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}>
                                                <i>
                                                    {isSelectOpen === 'RLM_MachineType' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                                                </i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-10 m-2">
                                    <div className="label-input-container">
                                        <label>
                                            Status
                                            {emptyFields.includes('status') && (
                                                <span style={{ color: 'red' }}> *</span>
                                            )}
                                        </label>
                                        <div className="select-container">
                                            <Select
                                                className="routing_select-box"
                                                options={[
                                                    { value: 1, label: 'Active' },
                                                    { value: 2, label: 'Inactive' },
                                                ]}
                                                value={
                                                    [{ value: 1, label: 'Active' }, { value: 2, label: 'Inactive' }]
                                                        .find(opt => opt.value === formdata.GRPM_GroupStatus) || null
                                                }
                                                onChange={(option) =>
                                                    handleChange(option, { name: 'GRPM_GroupStatus' })
                                                }
                                                placeholder="--Select--"
                                                onMenuOpen={() => handleSelectOpen('GRPM_GroupStatus')}
                                                onMenuClose={handleSelectClose}
                                                maxMenuHeight={140}
                                                isOptionDisabled={(option) => option.disabled}
                                                isDisabled={isRowEditing}
                                                isSearchable={false}
                                                components={{ SingleValue: CustomSingleValue }}
                                            />
                                            <div className="icon-container_list myList">
                                                <i>
                                                    {isSelectOpen === 'GRPM_GroupStatus' ? (
                                                        <IoCaretUpOutline />
                                                    ) : (
                                                        <IoCaretDownOutline />
                                                    )}
                                                </i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-5'>
                                <div className='column-2'>
                                    <div className="col-sm-12">
                                        <div className="label-input-container">
                                            <label>
                                                Group Rights {emptyFields.includes('grouprights') && <span style={{ color: 'red' }}> *</span>}
                                            </label>
                                            <div className='group_rights_container'>
                                                <MenuTree
                                                    selectedKeys={selectedGroupRights}
                                                    setSelectedKeys={setSelectedGroupRightsWithValidation}
                                                    disabled={false}
                                                    allAvailableKeys={allAvailableKeys}
                                                    isTreeView={isTreeView}
                                                    menuData={menuData}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="column-2"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-start", // ✅ pushes content left
                                        gap: "6px"
                                    }}
                                >
                                    <button
                                        type="button"
                                        className="add_btn"
                                        onClick={() => {
                                            handleAddRow();
                                            setShowUpdateRequired(false);
                                        }}
                                        style={{
                                            flexShrink: 0,
                                            minWidth: "max-content",
                                            padding: "6px 14px",
                                            fontWeight: "bold"
                                        }}
                                    >
                                        {editingRowIndex !== null ? "UPDATE" : "ADD"}
                                    </button>

                                    {showUpdateRequired && editingRowIndex !== null && (
                                        <span
                                            style={{
                                                color: "red",
                                                fontSize: "22px",
                                                fontWeight: "bold",
                                                lineHeight: "1",
                                            }}
                                        >
                                            *
                                        </span>
                                    )}
                                </div>


                            </div>
                        </div>
                    </div>
                    {tableList.length > 0 && (
                        <table className='tableClass mt-4' striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Machine Type</th>
                                    <th>Machine Rights</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableList.map((row, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{row.machineType}</td>
                                        <td>
                                            <Link>
                                                <img
                                                    src={Icon9}
                                                    alt="Pool"
                                                    title='Show Rights'
                                                    onClick={!isRowEditing ? () => handlePoolButtonClick(row) : undefined}
                                                    style={{
                                                        cursor: isRowEditing ? 'not-allowed' : 'pointer',
                                                        opacity: isRowEditing ? 0.4 : 1
                                                    }}
                                                />
                                            </Link>
                                        </td>
                                        <td>
                                            <Link className='m-1'>
                                                <img
                                                    src={Icon3}
                                                    alt="Edit"
                                                    onClick={!isRowEditing ? () => handleEditRow(index) : undefined}
                                                    title='Edit'
                                                    style={{
                                                        cursor: isRowEditing ? 'not-allowed' : 'pointer',
                                                        opacity: isRowEditing ? 0.4 : 1
                                                    }}
                                                />
                                            </Link>
                                            <Link className='m-1'>
                                                <img
                                                    src={Icon5}
                                                    alt="Remove"
                                                    title='Remove'
                                                    onClick={!isRowEditing ? () => handleRemoveClick(index, row.machineType) : undefined}
                                                    style={{
                                                        cursor: isRowEditing ? 'not-allowed' : 'pointer',
                                                        opacity: isRowEditing ? 0.4 : 1
                                                    }}
                                                />
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}

                    <Modal
                        show={showModal}
                        onHide={() => setShowModal(false)}
                        size="lg"
                        backdrop="static"
                        centered
                        keyboard={false}
                        animation={false}
                        style={{ backdropFilter: 'blur(3px)', backgroundColor: 'rgba(0, 0, 0, 0.3)' }}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>
                                Password Policy Details
                            </Modal.Title>
                        </Modal.Header>

                        <Modal.Body style={{ textAlign: 'left' }}>
                            <h6>
                                Policy : {selectedPolicyDetails?.CITPM_PolicyName}
                            </h6>

                            <table className="tableClass">
                                <tbody>
                                    <tr>
                                        <th style={{ backgroundColor: 'transparent' }}>Session Time Out (Minutes)</th>
                                        <td>{selectedPolicyDetails?.CITPM_SessionTimeOut || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <th style={{ backgroundColor: 'transparent' }}>Password Attempts</th>
                                        <td>{selectedPolicyDetails?.CITPM_FailAttempt || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <th style={{ backgroundColor: 'transparent' }}>Password Never Expire</th>
                                        <td>{selectedPolicyDetails?.CITPM_PwdNeverExpiry || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <th style={{ backgroundColor: 'transparent' }}>Password Change Duration (Days)</th>
                                        <td>{selectedPolicyDetails?.CITPM_PwdChangeDuration || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <th style={{ backgroundColor: 'transparent' }}>Password Expire Notification (Days)</th>
                                        <td>{selectedPolicyDetails?.CITPM_PwdNotificationDuration || 'N/A'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </Modal.Body>


                    </Modal>

                    <ToastContainer style={{ marginTop: '73px', fontSize: '14px', width: '40%' }} />
                    {showPopup && (
                        <div className="popup_overlay"
                            style={{
                                backdropFilter: "blur(4px)",
                                backgroundColor: "rgba(0,0,0,0.3)"
                            }}>
                            <div className="popup" style={{ height: '645px' }}>
                                <div>
                                    <Link onClick={() => setShowPopup(false)}><Image src={x} alt="x" className="x" /></Link>
                                </div>
                                <h5 className="modal-title">Machine : {selectedMachineType}</h5>
                                <table className="tableClass">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Rights</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{
                                        display: 'block',
                                        maxHeight: '220px',
                                        overflowY: 'auto'
                                    }}>
                                        {popupSelectedSubMenus.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.subMenuOptions.join(', ')}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                    {removeConfirmationModal && (
                        <div className="popup_overlay"
                            style={{
                                backdropFilter: "blur(4px)",
                                backgroundColor: "rgba(0,0,0,0.3)"
                            }}>
                            <div className="resetpopup">
                                <h1>:: User Confirmation ::</h1>
                                <h4> Are you sure you want to remove rights for Machine : {selectedMachineType} ?</h4>
                                <div className="popup_btn_container">
                                    <button className="yes_btn" onClick={confirmRemoveRow}>
                                        YES
                                    </button>
                                    <button className="no_btn" onClick={cancelRemoveRow}>
                                        NO
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="button-container">
                    <button type="submit" className="save_btn" style={{
                        cursor: 'pointer'
                    }}>SAVE</button>
                    <button type="button" className="reset_btn" onClick={handleCancel}>RESET</button>
                    <Link
                        to="/gmlist"
                        className="list_btn"
                        onClick={(e) => {
                            if (editingRowIndex !== null) {
                                e.preventDefault(); // ✅ Stop navigation
                                setShowUpdateRequired(true);
                            }
                        }}
                    >
                        LIST
                    </Link>

                </div>
            </form>
        </React.Fragment>
    );
}

export default GroupMaster;





